// react-native-image-crop-picker for the web, built on the image-picker shim's
// file input. There is no cropper, so the picked image is returned whole, in
// the crop picker's { path, mime, filename } shape. Cancelling rejects with
// E_PICKER_CANCELLED like on mobile.
import {launchCamera, launchImageLibrary} from './image-picker';

const toImage = response => {
  if (response.didCancel) {
    throw Object.assign(new Error('User cancelled image selection'), {
      code: 'E_PICKER_CANCELLED',
    });
  }
  if (response.errorCode) {
    throw Object.assign(new Error(response.errorMessage), {
      code: 'E_PICKER_ERROR',
    });
  }
  const asset = response.assets[0];
  return {
    path: asset.uri,
    mime: asset.type,
    filename: asset.fileName,
    size: asset.fileSize,
    width: asset.width,
    height: asset.height,
  };
};

const ImageCropPicker = {
  openCamera: (options = {}) => launchCamera(options).then(toImage),
  openPicker: (options = {}) => launchImageLibrary(options).then(toImage),
  openCropper: options => Promise.resolve(options),
  clean: () => Promise.resolve(),
  cleanSingle: () => Promise.resolve(),
};

export default ImageCropPicker;
